import { takeLatest } from 'redux-saga/effects';
import loadUsersTenantSaga from './loadUsersTenantSaga';
import loadFilterUsersSaga from './loadFilterUsersSaga';
import loadInvitedLinemenByLocationSaga from './loadLinemenByLocationSaga';
import notifyUsersSaga from './notifyUsersSaga';
import { TYPES } from '../constants';
import loadUsersFavoritesSaga from './loadUsersFavoritesSaga';
import loadTenantWorkersSaga from './loadTenantWorkersSaga';
import loadTenantSupportersSaga from './loadTenantSupportersSaga';
import loadAvailabldSharedUsersSaga from './loadAvailableSharedUsersSaga';
import loadUserFavoritesSaga from './loadUserFavoritesSaga';
import bulkUploadUsersSaga from './bulkUploadUsersSaga';
import loadPossibleRosterOwnersSaga from './loadPossibleRosterOwnersSaga';

export default function* usersSagas(): Generator {
  yield takeLatest(TYPES.LOAD_USERS_TENANT.INIT, loadUsersTenantSaga);
  yield takeLatest(TYPES.LOAD_USERS_FAVORITES.INIT, loadUsersFavoritesSaga);
  yield takeLatest(TYPES.LOAD_FILTER_USERS.INIT, loadFilterUsersSaga);
  yield takeLatest(TYPES.LOAD_INVITED_LINEMEN_BY_LOCATION.INIT, loadInvitedLinemenByLocationSaga);
  yield takeLatest(TYPES.NOTIFY_USERS.INIT, notifyUsersSaga);
  yield takeLatest(TYPES.LOAD_TENANT_WORKERS.INIT, loadTenantWorkersSaga);
  yield takeLatest(TYPES.LOAD_TENANT_SUPPORTERS.INIT, loadTenantSupportersSaga);
  yield takeLatest(TYPES.LOAD_AVAILABLE_SHARED_USERS.INIT, loadAvailabldSharedUsersSaga);
  yield takeLatest(TYPES.LOAD_USER_FAVORITES.INIT, loadUserFavoritesSaga);
  yield takeLatest(TYPES.BULK_UPLOAD_USERS.INIT, bulkUploadUsersSaga);
  yield takeLatest(TYPES.LOAD_POSSIBLE_ROSTER_OWNERS.INIT, loadPossibleRosterOwnersSaga);
}
